import client from './client';

const postsAPI = {
  // Get all published posts with pagination and filters
  getPosts: async (page = 1, limit = 12, category = null) => {
    const params = { page, limit };
    if (category) {
      params.category = category;
    }
    const response = await client.get('/posts', { params });
    return response.data;
  },

  // Get single post by slug
  getPostBySlug: async (slug) => {
    const response = await client.get(`/posts/${slug}`);
    return response.data;
  },

  // Create new post (admin)
  createPost: async (postData) => {
    const response = await client.post('/posts', postData);
    return response.data;
  },

  // Update post (admin)
  updatePost: async (postId, postData) => {
    const response = await client.put(`/posts/${postId}`, postData);
    return response.data;
  },

  // Delete post (admin)
  deletePost: async (postId) => {
    const response = await client.delete(`/posts/${postId}`);
    return response.data;
  },

  // Toggle publish status (admin)
  togglePublish: async (postId) => {
    const response = await client.patch(`/posts/${postId}/publish`);
    return response.data;
  }
};

export default postsAPI;
